import React from 'react';
import { socialLinks } from './data';
import Link from 'next/link';
import { Trackable } from '@/components/common';

export default function FooterBootom(): React.ReactNode {
  return (
    <div className='mt-8 flex flex-col-reverse items-center justify-between border-t border-white/10 pt-8 sm:flex-row'>
      <p className='text-center text-sm/6 text-gray-400'>
        &copy; LFYD SERVICES PRIVATE LIMITED • All rights reserved
      </p>
      <div className='flex gap-x-6 pb-6 sm:pb-0'>
        {socialLinks.map((item, index) => (
          <Trackable
            key={`${item.name}_${index}`}
            eventName='Click'
            eventScope={`${item.name} Link (Footer)`}
          >
            <Link
              href={item.href}
              target='_blank'
              className='text-gray-400 hover:text-gray-300'
            >
              <span className='sr-only'>{item.name}</span>
              {React.createElement(item.icon!, {
                className: 'size-5',
              })}
            </Link>
          </Trackable>
        ))}
      </div>
    </div>
  );
}
